import { render } from "./SectionTitle.vue?vue&type=template&id=63bb8527"
const script = {}
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "63bb8527"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63bb8527', script)) {
    api.reload('63bb8527', script)
  }
  
  module.hot.accept("./SectionTitle.vue?vue&type=template&id=63bb8527", () => {
    api.rerender('63bb8527', render)
  })

}

script.__file = "resources/js/Jetstream/SectionTitle.vue"

export default script